import {deepmerge} from "@mui/utils";
import {createTheme} from "@mui/material/styles";
import {nlNL} from '@mui/x-date-pickers/locales'
import {defaultThemeOptions} from "./default.tsx";

export const anthraciteThemeOptions: Parameters<typeof createTheme>[0] = deepmerge(defaultThemeOptions, {
    palette: {
        mode: 'dark',
        background: {
            default: "#1f1e1f",
            paper: "#2b2a2b"
        },
        primary: {
            main: "#C2B8B2"
        },
        secondary: {
            main: "#484748"
        },
        error: {
            main: "#DF2935"
        },
        info: {
            main: "#197BBD"
        },
        text: {
            primary: '#f8f6f2',
            secondary: '#ece9de',
            disabled: '#e2daca'
        }
    },
})

export default createTheme(anthraciteThemeOptions, nlNL);
